/* eslint-disable no-underscore-dangle */
import { extend } from '../../shared/utils';

function createStore(storeParams = {}) {
  const store = {
    __store: true,
  };
  const originalState = { ...(storeParams.state || {}) };
  const actions = { ...(storeParams.actions || {}) };
  const getters = { ...(storeParams.getters || {}) };
  const state = extend({}, originalState);

  let propsQueue = [];
  const gettersDependencies = {};
  const gettersCallbacks = {};

  Object.keys(getters).forEach((key) => {
    gettersDependencies[key] = [];
    gettersCallbacks[key] = [];
  });
  const addGetterDependencies = (key, deps) => {
    if (!gettersDependencies[key]) gettersDependencies[key] = [];
    deps.forEach((dep) => {
      if (gettersDependencies[key].indexOf(dep) < 0) {
        gettersDependencies[key].push(dep);
      }
    });
  };

  const addGetterCallback = (key, callback) => {
    if (!gettersCallbacks[key]) gettersCallbacks[key] = [];
    gettersCallbacks[key].push(callback);
  };

  const runGetterCallbacks = (stateKey, value) => {
    const keys = Object.keys(gettersDependencies).filter((getterKey) => {
      return gettersDependencies[getterKey].indexOf(stateKey) >= 0;
    });
    keys.forEach((getterKey) => {
      if (!gettersCallbacks[getterKey] || !gettersCallbacks[getterKey].length) return;
      gettersCallbacks[getterKey].forEach((callback) => {
        callback(value);
      });
    });
  };

  const removeGetterCallback = (callback) => {
    Object.keys(gettersCallbacks).forEach((key) => {
      const callbacks = gettersCallbacks[key];

      if (callbacks.indexOf(callback) >= 0) {
        callbacks.splice(callbacks.indexOf(callback), 1);
      }
    });
  };

  // eslint-disable-next-line
  store.__removeCallback = (callback) => {
    removeGetterCallback(callback);
  };

  const getterValue = (key) => {
    if (key === 'constructor') return;
    propsQueue = [];
    const value = getters[key]({ state: store.state });
    addGetterDependencies(key, propsQueue);
    const onUpdated = (callback) => {
      addGetterCallback(key, callback);
    };

    const obj = {
      value,
      onUpdated,
    };
    const callback = (v) => {
      obj.value = v;
    };

    obj.__callback = callback;
    addGetterCallback(key, callback);
    // eslint-disable-next-line
    return obj;
  };

  store.state = new Proxy(state, {
    set: (target, prop, value) => {
      target[prop] = value;
      runGetterCallbacks(prop, value);
      return true;
    },
    get: (target, prop) => {
      propsQueue.push(prop);
      return target[prop];
    },
  });

  store.getters = new Proxy(getters, {
    set: () => false,
    get: (target, prop) => {
      if (!target[prop]) {
        return undefined;
      }
      return getterValue(prop);
    },
  });

  store.dispatch = (actionName, data) => {
    return new Promise((resolve, reject) => {
      if (!actions[actionName]) {
        reject();
        throw new Error(`ZMA: Store action "${actionName}" is not found`);
      }
      const result = actions[actionName]({ state: store.state, dispatch: store.dispatch }, data);
      resolve(result);
    });
  };

  return store;
}

export default createStore;
